const LOGIN_TIMESTAMP_KEY = "blitz_login_timestamp";
const LOGOUT_EVENT_KEY = "blitz_logout_event";
const SESSION_KEY = "blitz_session_active";
const USER_ID_KEY = "user_id";
const USER_ROLE_KEY = "user_role";
const USER_EMAIL_KEY = "user_email";

export const EIGHT_HOURS_MS = 8 * 60 * 60 * 1000;

export const authSessionKeys = {
  LOGIN_TIMESTAMP_KEY,
  LOGOUT_EVENT_KEY,
  SESSION_KEY,
  USER_ID_KEY,
  USER_ROLE_KEY,
  USER_EMAIL_KEY,
} as const;

export const setLoginTimestamp = (timestamp = Date.now()): void => {
  localStorage.setItem(LOGIN_TIMESTAMP_KEY, String(timestamp));
  sessionStorage.setItem(SESSION_KEY, "true");
};

export const getLoginTimestamp = (): number | null => {
  const rawValue = localStorage.getItem(LOGIN_TIMESTAMP_KEY);
  if (!rawValue) return null;

  const parsedValue = Number(rawValue);
  if (!Number.isFinite(parsedValue) || parsedValue <= 0) return null;

  return parsedValue;
};

export const isSessionExpired = (
  now = Date.now(),
  timeoutMs = EIGHT_HOURS_MS
): boolean => {
  const loginTimestamp = getLoginTimestamp();
  if (loginTimestamp === null) return true;
  return now - loginTimestamp > timeoutMs;
};

export const clearAuthSessionData = (): void => {
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(USER_ROLE_KEY);
  localStorage.removeItem(USER_EMAIL_KEY);
  localStorage.removeItem(LOGIN_TIMESTAMP_KEY);
  sessionStorage.removeItem(SESSION_KEY);
};

export const broadcastLogoutEvent = (timestamp = Date.now()): void => {
  localStorage.setItem(LOGOUT_EVENT_KEY, String(timestamp));
};
